const ArchiveMusicVideos2020Static = () => {
    return (
      <>
        <div class="music-video">

        <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/7YjcSy1XSxA" title="how u doing?" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            how u doing? (prod. quimmine)
          </p> 

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/-F6EolbbvMs" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Blossom
          </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/YwfcLWMmelo" title="CONDITIONED ASSOCIATIONS" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            CONDITIONED ASSOCIATIONS
          </p> 

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/kXeKwQsEtg4" title="Hellscape Radio Vol. 3" allowfullscreen></iframe>
            </div>
            <p class="video-title-text">
            <strong>Hellscape Radio, Vol. 3</strong><br/>
            (Hosted by ANJU Online!)
            </p>

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/3sdp4H8AweY" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>I Was Broke Last Weekend (Now I'm Up)</strong>
          </p>  

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/kErw7AAVk0k" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Lil Dujour</strong><br/>
            Cruel Summer
          </p>   

          <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/hmxTwaOksgI" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>Shawty, Pt. 2</strong>
          </p>    

            <div class="music-video-container">
            <iframe src="https://www.youtube.com/embed/igBUEgE6bQA" title="lost freestyle" allowfullscreen></iframe>
          </div>
          <p class="video-title-text">
            <strong>rileylol</strong><br/>
            lost freestyle (prod. elxnce)
          </p>    

        </div>
      </>
    );
  };
  export default ArchiveMusicVideos2020Static;